import React from 'react';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'default' | 'grid' | 'gradient';
}

const Section: React.FC<SectionProps> = ({ 
  children, 
  className = '', 
  id,
  background = 'default' 
}) => {
  const backgrounds = {
    default: 'bg-background',
    grid: 'bg-background grid-pattern',
    gradient: 'bg-gradient-to-b from-background via-background/95 to-background',
  };
  
  const sectionClasses = `section-padding ${backgrounds[background]} ${className}`;
  
  return (
    <section id={id} className={sectionClasses}>
      <div className="container-custom">
        {children}
      </div>
    </section>
  );
};

export default Section;
